export default __webpack_public_path__ + "static/media/emptyImage.539baad1.PNG";